<template>
  <header class="header-wrp-outer" :style="{
      'background-color':$route.meta.logo.background
  }">
      <div class="content-box header-wrp-inner">
          <router-link to="/bh" class="header-bh-txt">B"H</router-link>
          <logo/>
          <menu-trigger/>
      </div>
  </header>
</template>

<script>
import Logo from './Logo'
import MenuTrigger from './Menu'
export default {
    components:{
        Logo,
        MenuTrigger
    }
}
</script>

<style lang="scss">
.header-wrp-outer{
    padding:45px 0;
}

.header-wrp-inner{
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
}

.header-bh-txt{
    color: #818181;
    position: absolute;
    top: -60%;
    font: {
        size: 11px;
        weight:500 ;
    }

}

@media screen and (max-width: 800px){
    .header-wrp-outer{
        padding:35px 0;
    }
}

@media screen and (max-width: 0px){
    .header-wrp-outer{
        padding:35px 0;
    }
}
</style>